import type { BetterFetch } from "@better-fetch/fetch";
import { atom } from "nanostores";
import { authEndpointContract } from "../../shared/contracts/auth.contracts";
import type {
	GetSessionResponse,
	LoginMutationRequest,
} from "../../shared/types/authApi.types";
import {
	createQuerySetMap,
	extractListeners,
	extractQueries,
	extractSignals,
} from "../shared/queryFactory";

// Create auth core subfeature plugin
export function createAuthCorePlugin($fetch: BetterFetch) {
	const querySets = createQuerySetMap(authEndpointContract, $fetch);

	return {
		signals: extractSignals(querySets),
		queries: extractQueries(querySets),
		listeners: extractListeners(querySets),
		atoms: {
			// User state
			$user: atom<GetSessionResponse["status"]["user"] | null>(null),
			$isAuthenticated: atom<boolean>(false),
			$isLoading: atom<boolean>(false),
			$error: atom<string | null>(null),
			$session: atom<any>(null),
		},
		actions: {
			async login(credentials: LoginMutationRequest) {
				const result: typeof authEndpointContract.login.responseType =
					await $fetch(authEndpointContract.login.path, {
						method: authEndpointContract.login.method,
						throw: true,
						body: credentials,
					});
				return result;
			},

			async logout() {
				const result: typeof authEndpointContract.logout.responseType =
					await $fetch(authEndpointContract.logout.path, {
						method: authEndpointContract.logout.method,
						throw: true,
					});
				return result;
			},

			async getSession() {
				const result: typeof authEndpointContract.getSession.responseType =
					await $fetch(authEndpointContract.getSession.path, {
						method: authEndpointContract.getSession.method,
						throw: true,
					});
				return result;
			},
		},
		querySets, // Expose for advanced usage
	};
}
